import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 0,
      name: i18n.t('invoices.invoices_issuing.step2.normal')
    },
    {
      id: 1,
      name: i18n.t('invoices.invoices_issuing.step2.exenta_tax')
    },
    {
      id: 2,
      name: i18n.t('invoices.invoices_issuing.step2.no_sujeta_tax')
    },
    {
      id: 3,
      name: i18n.t('invoices.invoices_issuing.step2.sujeto_pasivo_tax'),
    }
  ]
}

export function TIPOS_OPERACION_TRIBUTACION (state) {
  return configHelper.getConfig(state, 'TIPOS_OPERACION_TRIBUTACION', GenerateConfig)
}
